// Tags rápidos de Kiltro — chips que el usuario puede tickear al reseñar
export const REVIEW_TAGS = [
  "buena terraza",
  "chela helada",
  "buena atención",
  "buen precio",
  "música top",
  "ambiente perro",
  "buena pizza",
  "tap rotativo",
  "lugar pet-friendly",
  "ideal para previa",
  "buena jarra",
  "rico picoteo",
];
